import React, { useState, useRef, useEffect } from 'react';

import { useAuth } from "react-oidc-context";
import { useNavigate } from 'react-router-dom';

function PreviouslyGeneratedStories() {
  const booksRef = useRef([]);
  const [username, setUsername] = useState();

  const [books, setBooks] = useState([]);
  const navigate = useNavigate();
  const auth = useAuth();


  useEffect(() => {
    // I may pass username as a parameter as that will load immideately when the page renders, which would like  a lil nicer
    if (auth.isAuthenticated){

      const username = auth.user.profile.username // i create a cont, username here because the below
      setUsername(auth.user.profile.username) // setUsername wont set until after the below code runs
      console.log('username')
      console.log(username)
      const fetchDataFromDynamoDB = async () => {
        try {

          const data = { client_reference_id: username };
          const response = await fetch("https://6cqkj6h200.execute-api.us-east-1.amazonaws.com/queryBookFromDynamo", {
            method: 'POST',
            mode: 'cors', // this cannot be 'no-cors'
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          });


          const res = await response.json();
          const book_objects = res["Items"]
          console.log("book_objects")
          console.log(book_objects)

          // Sort the data by date in descending order
          book_objects.sort((a, b) => new Date(b.last_save) - new Date(a.last_save));

          // Extract the 10 most recent dates
          let nine_most_recent_books = book_objects.slice(0, 9)

          console.log("book ref")
          console.log(booksRef)
          for (let i = 0; i < nine_most_recent_books.length; i++) {

            let pages_in_book = Number(nine_most_recent_books[i]['pages_in_book'])

            if (!booksRef.current.includes(nine_most_recent_books[i].book_id) && nine_most_recent_books[i][`page ${pages_in_book - 1}`]){
              console.log("hee haw")


              //////////
              const response = await fetch("https://ihwc8lc6n4.execute-api.us-east-1.amazonaws.com/createUrlForImage", {
                method: 'POST',
                mode: 'cors', // this cannot be 'no-cors'
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({images : [nine_most_recent_books[i]["image 0"]] }),
              });
              const temp_url = await response.json();
              /////////////
              setBooks((prevBooks) => {

                nine_most_recent_books[i]['temporary_url'] = temp_url
                booksRef.current.push(nine_most_recent_books[i].book_id);
                console.log(nine_most_recent_books[i])
                prevBooks.push(nine_most_recent_books[i])
                return [...prevBooks];

              })
            }
        }

        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      fetchDataFromDynamoDB()

      const interval = setInterval(fetchDataFromDynamoDB, 10000); // Adjust the interval (e.g., 10000ms = 10 seconds)
      return () => clearInterval(interval); // Cleanup on unmount
    }

    }, [auth.isAuthenticated])


  const handleImageClick = async (book_data) => {
    console.log("book data")
    console.log(book_data)
    const book_id = book_data['book_id']

    // everything below up until the next // should be put in NewPage.js
    let pages = []
    let grammaticalErrorPages = []
    let imageS3Paths = []
    for (let i = 0; i < book_data['pages_in_book']; i++) {
      pages.push(book_data[`page ${i}`])
      if (book_data[`grammatical_error_page ${i}`]){
        grammaticalErrorPages.push(book_data[`grammatical_error_page ${i}`])
      }
      imageS3Paths.push(book_data[`image ${i}`])

    }


    const response = await fetch("https://ihwc8lc6n4.execute-api.us-east-1.amazonaws.com/createUrlForImage", {
      method: 'POST',
      mode: 'cors', // this cannot be 'no-cors'
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({images : imageS3Paths }),
    });
    const temp_images_urls = await response.json();
    //

    navigate(`/book/${book_id}/${username}`, { state:  {story_text: pages, image_links : temp_images_urls, gramatical_error_story_text: grammaticalErrorPages}  });

    //alert(`You clicked on: ${book_data}`);
  };

  return (
    <div className="gallery-container">
        <div className="auth-buttons">
          <button onClick={() => navigate('/')}>Create Another Story</button>
        </div>

        {books.map((image) => (
          <img
            key={image.book_id}
            src={image.temporary_url}
            alt={image.last_save}
            className="image"
            onClick={() => handleImageClick(image)}
          />
        ))}
    </div>
  );

}

export default PreviouslyGeneratedStories;
